export default __webpack_public_path__ + "static/media/sticker-a.b828ee75.png";